<script>
  
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();
  
  function fromPageCoords(ctx, pagePos) { // ctx is svg context (svg element parent/group containing all transforms)
    var point = ctx.ownerSVGElement.createSVGPoint()
    Object.assign(point, pagePos)
    var matrix = ctx.getScreenCTM()
    var {x,y} = point.matrixTransform(matrix.inverse())
    return {x,y}
  }
  
  function getXY(evt){ 
    return { x: evt.clientX, y: evt.clientY } 
  }

  function startDrag(event) {
    event.preventDefault()

    function onMove(event) {
      dispatch('move', xy(event))
    }

    let target = event.target
    let xy = evt => fromPageCoords( target, getXY(evt) )
    let pos  = xy(event)
    dispatch('start-drag',{target,pos})

    document.addEventListener('mousemove', onMove)
    document.addEventListener('mouseup', endDrag)
  
    function endDrag (event) {
      let pos  = xy(event)
      dispatch('end-drag',{target,pos})
      document.removeEventListener('mousemove', onMove)
      document.removeEventListener('mouseup', endDrag)
    }
  }

</script>

<g on:mousedown="{startDrag}">
  <slot></slot>
</g>
